import { DateTime } from 'luxon';
import { api } from './api';

const PARIS_TIMEZONE = 'Europe/Paris';

function toGuestEventUTCISO(date, time, timezone = PARIS_TIMEZONE) {
  return DateTime.fromISO(`${date}T${time}`, { zone: timezone }).toUTC().toISO();
}

export function buildGuestEventPayloadFromForm({
  title,
  date,
  startTime,
  endTime,
  isAllDay = false,
}) {
  return {
    title,
    start_time: toGuestEventUTCISO(date, startTime),
    end_time: toGuestEventUTCISO(date, endTime),
    is_all_day: isAllDay,
  };
}

export function buildGuestEventPayloadFromCalendarEvent(event, timezone = PARIS_TIMEZONE) {
  const resolvedEnd = event.end || new Date(event.start.getTime() + 60 * 60 * 1000);

  return {
    title: event.title,
    start_time: DateTime.fromJSDate(event.start).setZone(timezone).toUTC().toISO(),
    end_time: DateTime.fromJSDate(resolvedEnd).setZone(timezone).toUTC().toISO(),
    is_all_day: event.allDay,
  };
}

export function getGuestEventId(event) {
  return event?.id || event?.extendedProps?.reservationId || null;
}

export function getGuestEventApiErrorCode(error) {
  return error?.data?.error?.code || error?.data?.code || error?.code || null;
}

export async function createGuestEvent(guestId, payload) {
  return api.post(`/guest-artists/${guestId}/events`, payload);
}

export async function updateGuestEvent(guestId, eventId, payload) {
  return api.put(`/guest-artists/${guestId}/events/${eventId}`, payload);
}

export async function deleteGuestEvent(guestId, eventId) {
  return api.delete(`/guest-artists/${guestId}/events/${eventId}`);
}
